import Image from 'next/image';

interface StyledImageProps {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    className?: string;
    rounded?: 'default' | 'large' | 'xl' | 'pill' | 'circle';
    shadow?: boolean;
    rotate?: 'none' | 'light' | 'strong';
    priority?: boolean;
}

export default function StyledImage({
    src,
    alt,
    width = 600,
    height = 400,
    className = '',
    rounded = 'default',
    shadow = true,
    rotate = 'light',
    priority = false,
}: StyledImageProps) {
    const roundedClasses = {
        default: 'rounded-[2rem]',
        large: 'rounded-[2rem]',
        xl: 'rounded-[2.5rem]',
        pill: 'rounded-[2.5rem]',
        circle: 'rounded-full',
    };

    // Playful hover lift, matching the homepage feel
    const rotateClasses = {
        none: '',
        light: 'transform transition-transform duration-500 hover:rotate-2',
        strong: 'transform transition-transform duration-500 hover:rotate-3',
    };

    const shadowClass = shadow ? 'shadow-lg' : '';

    // Chunky yellow frame, matching the homepage image treatment
    const borderClass = 'border-[8px] border-[#ffc64a] bg-[#ffc64a]';

    return (
        <div className={`relative overflow-hidden ${roundedClasses[rounded]} ${shadowClass} ${rotateClasses[rotate]} ${borderClass} ${className}`}>
            <Image
                src={src}
                alt={alt}
                width={width}
                height={height}
                className="w-full h-full object-cover"
                priority={priority}
            />
        </div>
    );
}
